export { Anchor, getFriendlySelector } from './Anchor';
